import { isMainSaaSHost } from "@/config/mainSaaSHost";
import { isStandaloneMode } from "@/config/pwa";

/** Kiracı alt alan adı veya özel domain vitrin sitesi (dashboard değil). */
export function isTenantPublicHost(hostname = "") {
  const h = String(
    hostname || (typeof window !== "undefined" ? window.location.hostname : "")
  ).toLowerCase();
  return Boolean(h) && !isMainSaaSHost(h);
}

/** PWA service worker yalnızca ana SaaS veya kurulu PWA için; vitrin ziyaretçilerinde gereksiz. */
export function shouldRegisterServiceWorker(hostname = "") {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return false;
  }
  if (isTenantPublicHost(hostname)) {
    return isStandaloneMode();
  }
  return true;
}
